module.exports = __webpack_public_path__ + "img/chart-gantt.e657a0bf.svg";